<template>
  <pl-dialog
    :title="'Almost there!'"
    :size="'md'"
    @close="closeModal"
    :disableOutsideClick="true"
  >
    <main class="center items-center p-5">
      <div class="text-md">
        <p class="px-2">
          An IT administrator at your school or district needs to approve the
          connection to <b>{{ integration_name }}</b> before we can connect.
        </p>
      </div>

      <div class="px-2 mt-4" v-if="getProfile.role === 'teacher'">
        <p class="font-bold">Admin Email</p>
        <input
          v-model="email"
          :placeholder="'Enter admin email'"
          class="bg-input text-sm text-gray-500 flex-grow outline-none my-2 py-2 w-full rounded rounded-l-none placeholder-gray-300"
        />
      </div>
    </main>
    <footer class="my-5 center items-center">
      <button
        class="px-10 py-2 w-40 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
        @click="sendEmail"
      >
        Send
      </button>
    </footer>
    <div v-if="error_msg" class="error_msg">Invalid Email</div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../utils/event-bus';

  export default {
    props: {
      integration_name: {
        type: String,
        default() {
          return '';
        },
      },
      integration_id: {
        type: String,
        default() {
          return '';
        },
      },
    },
    data() {
      return {
        email: '',
        error_msg: false,
      };
    },
    computed: {
      ...mapGetters(['getProfile']),
    },
    methods: {
      isAnEmail(email) {
        var regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
      sendEmail() {
        this.error_msg = false;

        if (!this.isAnEmail(this.email)) {
          this.error_msg = true;
          return;
        }

        this.$store
          .dispatch('sendEmailToAdmin', {
            integration_name: this.integration_name,
            admin_email: this.email,
            school_name: this.getProfile.school.name,
          })
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Email successfully sended.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            this.closeModal();
          });
      },
      closeModal() {
        if (
          this.$route.query.inviteModalOpen &&
          this.$route.query.roundtableID
        ) {
          this.$router.push({
            name: 'roundtable.index',
            params: {
              courseID: this.$route.params.courseID,
              roundtableID: this.$route.query.roundtableID,
            },
            query: {
              inviteModalOpen: true,
            },
          });
        } else if (
          this.$route.query.inviteModalOpen &&
          this.$route.query.liveDiscussionID
        ) {
          this.$router.push({
            name: 'live-discussion.index',
            params: {
              courseID: this.$route.params.courseID,
              liveDiscussionID: this.$route.query.liveDiscussionID,
            },
            query: {
              inviteModalOpen: true,
            },
          });
        }
        this.$emit('close');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// integrationsUpgradeModal.vue?7088fbca